<button class="status {{ status() }}" (click)="toggle.emit()">
  {{ status() | slice: 0 : 20 }}
</button>
